import { Modal } from "@mui/material";
import { useState } from "react";
import CloseCircleIcon from "./icons/closeCircle";

type ProductModelProps = {
	image: string;
	productModel: string;
	modalContent?: JSX.Element;
};

const ProductModel = ({
	image,
	productModel,
	modalContent,
}: ProductModelProps) => {
	const [modalOpen, setModalOpen] = useState(false);
	const closeModal = () => {
		setModalOpen(false);
	};
	const openModal = () => {
		setModalOpen(true);
	};

	return (
		<>
			<div
				className="flex flex-col sm:flex-row cursor-pointer"
				onClick={openModal}
				tabIndex={0}
			>
				<div className="px-[7px] py-[5px] w-[165px] h-[113px]">
					<div className="rounded-[6px] overflow-hidden border border-[#ccc] h-full">
						<img
							src={image}
							alt={productModel}
							className="w-full h-full object-contain"
						/>
					</div>
				</div>
				<div className="p-[10px] w-[171px] flex md:items-center">
					<p className="text-sm leading-4 font-bold underline text-teradyne-blue">
						{productModel}
					</p>
				</div>
			</div>
			{modalContent && (
				<Modal open={modalOpen} onClose={closeModal}>
					<div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 xl:w-[1060px] h-full md:h-fit w-full bg-light-blue border-[2px] rounded-[6px] border-electric-blue drop-shadow-md">
						<div className="p-[50px] relative w-full h-full text-charcoal">
							{modalContent}
							<div
								className="absolute top-[10px] right-[10px] z-10 text-electric-blue cursor-pointer"
								onClick={closeModal}
							>
								<CloseCircleIcon />
							</div>
						</div>
					</div>
				</Modal>
			)}
		</>
	);
};

export default ProductModel;
